module.exports = __webpack_public_path__ + "static/media/KidX.AI .92a88db4.png";